export default __webpack_public_path__ + "static/media/coderbyte.47c7092c.webp";